import apiClient from './client';

// ===== HAUPT-API FUNKTIONEN =====

export const programsAPI = {
  // Intelligente Programmsuche
  filterPrograms: async (filters) => {
    // Get current language from localStorage or default to 'de'
    const currentLanguage = localStorage.getItem('centeo-language') || 'de';
    
    // Add language to filters
    const filtersWithLanguage = {
      ...filters,
      language: currentLanguage
    };
    
    console.log('🌍 API: Adding language to request:', currentLanguage);
    const response = await apiClient.post('/programs/filter', filtersWithLanguage);
    return response;
  },

  // Einzelnes Programm abrufen
  getProgramById: async (id) => {
    const response = await apiClient.get(`/programs/${id}`);
    return response;
  },

  // Kategorien für Dropdowns
  getCategories: async () => {
    const response = await apiClient.get('/programs/meta/categories');
    return response;
  },

  // Health Check
  getHealth: async () => {
    const response = await apiClient.get('/health');
    return response;
  }
};

// ===== TYPED INTERFACES (optional mit TypeScript) =====

export const FARM_TYPES = [
  { value: 'dairy', label: 'Milchvieh' },
  { value: 'crops', label: 'Ackerbau' },
  { value: 'mixed', label: 'Gemischt' },
  { value: 'organic', label: 'Bio' },
  { value: 'livestock', label: 'Viehzucht' },
  { value: 'other', label: 'Sonstiges' }
];

export const COUNTRIES = [
  { 
    value: 'DE', 
    label: {
      de: 'Deutschland',
      es: 'Alemania', 
      it: 'Germania'
    }
  },
  { 
    value: 'ES', 
    label: {
      de: 'Spanien',
      es: 'España',
      it: 'Spagna'
    }
  },
  { 
    value: 'IT', 
    label: {
      de: 'Italien',
      es: 'Italia',
      it: 'Italia'
    }
  },
  { 
    value: 'AT', 
    label: {
      de: 'Österreich',
      es: 'Austria',
      it: 'Austria'
    }
  }
];

// Erweiterte Länder- und Regionsdaten für das "Wo"-Dropdown
export const LOCATIONS = {
  DE: {
    label: {
      de: 'Deutschland',
      es: 'Alemania',
      it: 'Germania'
    },
    regions: [
      { value: 'alle', label: { de: 'Alle Bundesländer', es: 'Todos los estados', it: 'Tutti gli stati' } },
      { value: 'Baden-Württemberg', label: { de: 'Baden-Württemberg', es: 'Baden-Württemberg', it: 'Baden-Württemberg' } },
      { value: 'Bayern', label: { de: 'Bayern', es: 'Baviera', it: 'Baviera' } },
      { value: 'Berlin', label: { de: 'Berlin', es: 'Berlín', it: 'Berlino' } },
      { value: 'Brandenburg', label: { de: 'Brandenburg', es: 'Brandeburgo', it: 'Brandeburgo' } },
      { value: 'Bremen', label: { de: 'Bremen', es: 'Bremen', it: 'Brema' } },
      { value: 'Hamburg', label: { de: 'Hamburg', es: 'Hamburgo', it: 'Amburgo' } },
      { value: 'Hessen', label: { de: 'Hessen', es: 'Hesse', it: 'Assia' } },
      { value: 'Mecklenburg-Vorpommern', label: { de: 'Mecklenburg-Vorpommern', es: 'Mecklemburgo-Pomerania Occidental', it: 'Meclemburgo-Pomerania Anteriore' } },
      { value: 'Niedersachsen', label: { de: 'Niedersachsen', es: 'Baja Sajonia', it: 'Bassa Sassonia' } },
      { value: 'Nordrhein-Westfalen', label: { de: 'Nordrhein-Westfalen', es: 'Renania del Norte-Westfalia', it: 'Renania Settentrionale-Vestfalia' } },
      { value: 'Rheinland-Pfalz', label: { de: 'Rheinland-Pfalz', es: 'Renania-Palatinado', it: 'Renania-Palatinato' } },
      { value: 'Saarland', label: { de: 'Saarland', es: 'Sarre', it: 'Saarland' } },
      { value: 'Sachsen', label: { de: 'Sachsen', es: 'Sajonia', it: 'Sassonia' } },
      { value: 'Sachsen-Anhalt', label: { de: 'Sachsen-Anhalt', es: 'Sajonia-Anhalt', it: 'Sassonia-Anhalt' } },
      { value: 'Schleswig-Holstein', label: { de: 'Schleswig-Holstein', es: 'Schleswig-Holstein', it: 'Schleswig-Holstein' } },
      { value: 'Thüringen', label: { de: 'Thüringen', es: 'Turingia', it: 'Turingia' } }
    ]
  },
  AT: {
    label: {
      de: 'Österreich',
      es: 'Austria',
      it: 'Austria'
    },
    regions: [
      { value: 'alle', label: { de: 'Alle Bundesländer', es: 'Todos los estados', it: 'Tutti gli stati' } },
      { value: 'Burgenland', label: { de: 'Burgenland', es: 'Burgenland', it: 'Burgenland' } },
      { value: 'Kärnten', label: { de: 'Kärnten', es: 'Carintia', it: 'Carinzia' } },
      { value: 'Niederösterreich', label: { de: 'Niederösterreich', es: 'Baja Austria', it: 'Bassa Austria' } },
      { value: 'Oberösterreich', label: { de: 'Oberösterreich', es: 'Alta Austria', it: 'Alta Austria' } },
      { value: 'Salzburg', label: { de: 'Salzburg', es: 'Salzburgo', it: 'Salisburgo' } },
      { value: 'Steiermark', label: { de: 'Steiermark', es: 'Estiria', it: 'Stiria' } },
      { value: 'Tirol', label: { de: 'Tirol', es: 'Tirol', it: 'Tirolo' } },
      { value: 'Vorarlberg', label: { de: 'Vorarlberg', es: 'Vorarlberg', it: 'Vorarlberg' } },
      { value: 'Wien', label: { de: 'Wien', es: 'Viena', it: 'Vienna' } }
    ]
  },
  ES: {
    label: {
      de: 'Spanien',
      es: 'España',
      it: 'Spagna'
    },
    regions: [
      { value: 'todas', label: { de: 'Alle Regionen', es: 'Todas las regiones', it: 'Tutte le regioni' } },
      { value: 'Andalucía', label: { de: 'Andalusien', es: 'Andalucía', it: 'Andalusia' } },
      { value: 'Aragón', label: { de: 'Aragonien', es: 'Aragón', it: 'Aragona' } },
      { value: 'Asturias', label: { de: 'Asturien', es: 'Asturias', it: 'Asturie' } },
      { value: 'Balearic Islands', label: { de: 'Balearen', es: 'Islas Baleares', it: 'Isole Baleari' } },
      { value: 'Canary Islands', label: { de: 'Kanarische Inseln', es: 'Islas Canarias', it: 'Isole Canarie' } },
      { value: 'Castilla y León', label: { de: 'Kastilien und León', es: 'Castilla y León', it: 'Castiglia e León' } },
      { value: 'Castilla-La Mancha', label: { de: 'Kastilien-La Mancha', es: 'Castilla-La Mancha', it: 'Castiglia-La Mancia' } },
      { value: 'Cataluña', label: { de: 'Katalonien', es: 'Cataluña', it: 'Catalogna' } },
      { value: 'Extremadura', label: { de: 'Extremadura', es: 'Extremadura', it: 'Estremadura' } },
      { value: 'Galicia', label: { de: 'Galicien', es: 'Galicia', it: 'Galizia' } },
      { value: 'Madrid', label: { de: 'Madrid', es: 'Madrid', it: 'Madrid' } },
      { value: 'Murcia', label: { de: 'Murcia', es: 'Murcia', it: 'Murcia' } },
      { value: 'Navarra', label: { de: 'Navarra', es: 'Navarra', it: 'Navarra' } },
      { value: 'País Vasco', label: { de: 'Baskenland', es: 'País Vasco', it: 'Paesi Baschi' } },
      { value: 'Valencia', label: { de: 'Valencia', es: 'Valencia', it: 'Valencia' } }
    ]
  },
  IT: {
    label: {
      de: 'Italien',
      es: 'Italia',
      it: 'Italia'
    },
    regions: [
      { value: 'tutte', label: { de: 'Alle Regionen', es: 'Todas las regiones', it: 'Tutte le regioni' } },
      { value: 'Abruzzo', label: { de: 'Abruzzen', es: 'Abruzzo', it: 'Abruzzo' } },
      { value: 'Basilicata', label: { de: 'Basilikata', es: 'Basilicata', it: 'Basilicata' } },
      { value: 'Calabria', label: { de: 'Kalabrien', es: 'Calabria', it: 'Calabria' } },
      { value: 'Campania', label: { de: 'Kampanien', es: 'Campania', it: 'Campania' } },
      { value: 'Emilia-Romagna', label: { de: 'Emilia-Romagna', es: 'Emilia-Romaña', it: 'Emilia-Romagna' } },
      { value: 'Friuli-Venezia Giulia', label: { de: 'Friaul-Julisch Venetien', es: 'Friuli-Venecia Julia', it: 'Friuli-Venezia Giulia' } },
      { value: 'Lazio', label: { de: 'Latium', es: 'Lacio', it: 'Lazio' } },
      { value: 'Liguria', label: { de: 'Ligurien', es: 'Liguria', it: 'Liguria' } },
      { value: 'Lombardia', label: { de: 'Lombardei', es: 'Lombardía', it: 'Lombardia' } },
      { value: 'Marche', label: { de: 'Marken', es: 'Marcas', it: 'Marche' } },
      { value: 'Molise', label: { de: 'Molise', es: 'Molise', it: 'Molise' } },
      { value: 'Piemonte', label: { de: 'Piemont', es: 'Piamonte', it: 'Piemonte' } },
      { value: 'Puglia', label: { de: 'Apulien', es: 'Puglia', it: 'Puglia' } },
      { value: 'Sardegna', label: { de: 'Sardinien', es: 'Cerdeña', it: 'Sardegna' } },
      { value: 'Sicilia', label: { de: 'Sizilien', es: 'Sicilia', it: 'Sicilia' } },
      { value: 'Toscana', label: { de: 'Toskana', es: 'Toscana', it: 'Toscana' } },
      { value: 'Trentino-Alto Adige', label: { de: 'Trentino-Südtirol', es: 'Trentino-Alto Adigio', it: 'Trentino-Alto Adige' } },
      { value: 'Umbria', label: { de: 'Umbrien', es: 'Umbría', it: 'Umbria' } },
      { value: 'Valle d\'Aosta', label: { de: 'Aostatal', es: 'Valle de Aosta', it: 'Valle d\'Aosta' } },
      { value: 'Veneto', label: { de: 'Venetien', es: 'Véneto', it: 'Veneto' } }
    ]
  }
};